"use strict";

function resizeWindow() {
	setTimeout(function () {
		equalize();
	}, 500);
}
function scrollDown() {}

$('#booking-form select').select2();

$(document).ready(function () {

	//Call function with browser is resized.
	$(window).resize(function (event) {
		resizeWindow();
	});
	resizeWindow();

	// Main Nav Dropdown 
	$("#primary-nav li").hover(function () {

		$(this).addClass("hover");
		$('ul.submenu', this).fadeIn(200);
	}, function () {

		$(this).removeClass("hover");
		$('ul.submenu', this).fadeOut(200);
	});

	// tablet menu
	$('.menu-trigger').click(function () {
		if ($(this).hasClass('open')) {
			$('#header .tablet-primary').fadeOut();
			var text = $(this).text();
			$('.menu-text').text('Menu');
			$('.menu-holder').removeClass('close');
		} else {
			$('#header .tablet-primary').fadeIn();
			$('.menu-text').text('Close');
			$('.menu-holder').addClass('close');
		}
	});
	$('.menu-trigger').click(function () {
		$(this).toggleClass('open');
	});

	//SUBNAVIGATION

	// Open active sub-nav on load
	$('.navigation ul.submenu li .active').parents().parents('li').addClass('item-open');
	$('.navigation ul.submenu li .active').closest('.sub-sub-menu').slideDown(300, 'easeOutQuart', function () {}).addClass('menu-open');

	//Toggle open/close on tap
	$('.navigation li a').off('click').on('click', function (event) {
		if ($(this).parent().children(".sub-sub-menu").length > 0) {

			event.preventDefault();

			if ($(this).next().hasClass('menu-open')) {
				$(this).parent().parent().removeClass('open');
				$(this).parent().removeClass('item-open');
				$(this).next().slideUp(300, 'easeOutQuart').removeClass('menu-open');
				console.log("close");
			} else {
				$(this).parent().parent().addClass('open');
				$(this).parent().addClass('item-open');
				$('.sub-sub-menu.menu-open').slideUp(300, 'easeOutQuart').removeClass('menu-open');
				$(this).next().slideDown(300, 'easeOutQuart', function () {}).addClass('menu-open');
				console.log("open");
			}
		}
	});
	// Navigation Available Max-Height
	var topSiblings = $('.navigation .inner').prevAll().outerHeight() + 20; // Add 20px padding-top
	var bottomSiblings = $('.navigation .inner').nextAll().height();
	var viewportHeight = $(window).height() * 0.95; // Substract 5% for top buttons

	var navigationHeight = viewportHeight - (bottomSiblings + topSiblings);
	$('.navigation .inner > ul').css("max-height", navigationHeight);
	// Remove the mobile redirect on tablet nav
	$(".tablet-primary .navigation .inner li a").each(function () {
		this.href = this.href.replace('/m/', '/');
	});

	$('#accordion').find('.accordion-toggle').click(function (e) {

		$(this).next().slideToggle('fast');
		$(this).toggleClass('active');

		$(".accordion").not($(this).next()).slideUp('fast');
		$(".accordion-toggle").not($(this)).removeClass('active');
	});
	$("div.accordion").addClass("defualt-hidden");

	// start ANIMATIONS
	// Init ScrollMagic
	//var controller = new ScrollMagic.Controller();

	$('.fancybox-copy').fancybox({
		wrapCSS: 'full-fancy-copy',
		'width': 760,
		'height': 560
	});

	$(".vidOpener").fancybox({
		'padding': 0,
		'type': 'iframe',
		'fitToView': true,
		'autoSize': true,
		'autoDimensions': true,
		'width': 760,
		'height': 560,
		'onComplete': function onComplete() {
			$('.fancybox-inner iframe').load(function () {
				// wait for frame to load and then gets it's height
				$('.fancybox-inner body').height($(this).contents().find('video').height() + 30);
			});
		}
	});

	if ($('body#home').length > 0) {
		//Home page scroll down arrow. If present.
		$('.arrow-home').click(function (event) {
			$('body, html').animate({
				scrollTop: $(window).height() - $('header').outerHeight() * 2 }, 800, 'easeOutExpo');
		});
	}

	//Remove empty <p> tags created by tinymce
	$('p').each(function () {
		var $this = $(this);
		if ($this.html().replace(/\s|&nbsp;/g, '').length == 0) $this.remove();
	});

	$('.all-transportions').find('h2').click(function () {
		var text = $(this).children('.toggle-cta').text();
		$('.all-transportions').find('h2').removeClass('open');
		$(this).toggleClass('open');
		//$(this).next('.slide-copy').slideToggle('fast');
		$(this).next().slideToggle('fast');
		$(".slide-copy").not($(this).next()).slideUp('fast');
	});

	$('.room-images').slick({
		arrows: true,
		dots: false,
		autoplay: false,
		autoplaySpeed: 4000,
		speed: 500,
		fade: true,
		accessibility: false
	});

	$('.request-btn').click(function () {
		$('.rfp-section').fadeIn();
		$('html,body').animate({
			scrollTop: $(".rfp-section").offset().top - 118
		});
	});
	$('.close-rfp').click(function () {
		$('.rfp-section').fadeOut();
	});

	$('.view-details').click(function () {
		$(this).parent().parent().next('div.full-copy').slideToggle();
		var text = $(this).text();
		$(this).text(text == "Hide Details" ? "View Details" : "Hide Details");
		$(this).toggleClass('open');
	});

	$('.fancybox-copy').fancybox({
		wrapCSS: 'fullFancyCopy'
	});

	$('.fancybox-events').fancybox({
		maxWidth: 450,
		maxHeight: 600,
		minWidth: 300,
		fitToView: false,
		width: '90%',
		height: '90%',
		autoSize: false,
		closeClick: false,
		afterLoad: function afterLoad() {
			$(".fancybox-overlay").addClass("fancybox-img-event");
		}
	});

	// $('.fancybox').fancybox({
	// });


	// Home Page Map
	$('#home').find('.map-home ul.pins li').hover(function () {
		$('#home').find('.map-home ul.pins li').removeClass('active');
		$(this).addClass('active');
		//$('.each-location').fadeOut();
		//$('#each-location'+$(this).attr('target')).fadeIn();
	});

	//Event Tracking
	//this class should be add to any link to the booking engine
	$('.book-now').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
	});
	//this class should be add to the header widget submit button
	$('.bookNow').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
	});

	$('.booking-trigger').click(function () {
		//$('#booking-form').fadeToggle();
		$('#smart-booking__container').fadeIn();
	});
	$('#close-booking').click(function () {
		$('#smart-booking__container').fadeOut();
	});
	/*
 var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
 	//Check in and check out datepicker for booking engine
 $( "#CheckIn" ).datepicker({
 	//showOn: "both",
 	//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
 	//buttonImageOnly: true,
 	changeMonth: true,
 	numberOfMonths: 2,
 	dateFormat : 'yy-mm-dd',
 	onSelect: function( selectedDate ) {
 		getDate = $(this).datepicker('getDate');
 		dayIn  = getDate.getDate();
 		monthIn = getDate.getMonth();
 		newDate = new Date(getDate.getTime());
 		$( ".checkin .date-num" ).html(dayIn);
 		$( ".checkin .month" ).html(monthNames[monthIn]);
 		newDate.setDate(newDate.getDate() + 3);
 		dayOut  = newDate.getDate();
 		monthOut = newDate.getMonth();
 		$( "#CheckOut" ).datepicker( "setDate", newDate );
 		$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
 		$( ".checkout .date-num" ).html(dayOut);
 		$( ".checkout .month" ).html(monthNames[monthOut]);
 	}
 });
 $( "#CheckOut" ).datepicker({
 	//showOn: "both",
 	//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
 	//buttonImageOnly: true,
 	changeMonth: true,
 	numberOfMonths: 2,
 	dateFormat: 'yy-mm-dd',
 	onSelect: function( selectedDate ) {
 		$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
 		getDate = $(this).datepicker('getDate');
 		dayOut  = getDate.getDate();
 		console.log(dayOut);
 		monthOut = getDate.getMonth();
 		$( ".checkout .date-num" ).html(dayOut);
 		$( ".checkout .month" ).html(monthNames[monthOut]);
 		}
 });
 */
	// Map: Return to previous page button. Change body id to match map template's name.
	$('body#map-category #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

	if (document.getElementById("myAudio")) {
		var togglePlay = function togglePlay() {
			isPlaying ? myAudio.pause() : myAudio.play();
		};

		var myAudio = document.getElementById("myAudio");
		var isPlaying = false;

		;

		myAudio.onplaying = function () {
			isPlaying = true;
		};
		myAudio.onpause = function () {
			isPlaying = false;
		};
	}
});

$(window).on('load', function () {

	//Slick Slider
	$('.sym-slides').slick();
});

if (document.getElementById('homeAudio') && document.getElementById('homeAudio-btn')) {

	var homeAudio = document.getElementById('homeAudio');
	var homeAudioBtn = document.getElementById('homeAudio-btn');

	homeAudioBtn.addEventListener('click', function () {
		playPause(homeAudio);
	});
}

function playPause(song) {
	console.log('playing song...');
	if (song.paused && song.currentTime >= 0 && !song.ended) {
		song.play();
	} else {
		song.pause();
	}
}

var allContentToExpand = document.querySelectorAll('.js-ContentExpandable');
allContentToExpand.forEach(function (eachContent) {
	var buttonToSwitch = eachContent.querySelector('.js-expandSpecials'),
	    toggleContent = eachContent.querySelector('.toggle-content');

	buttonToSwitch.addEventListener('click', function (e) {
		e.preventDefault();
		toggleContent.classList.toggle('hidden');
		if (buttonToSwitch.textContent == 'Read More +') {
			buttonToSwitch.textContent = 'Close Info -';
		} else {
			buttonToSwitch.textContent = 'Read More +';
		}
	});
});